const SvgClockGlyph = props => (
  <svg width={16} height={16} viewBox='0 0 16 16' {...props}>
    <path d='M11.536 4.464A4.954 4.954 0 008 3c-1.34 0-2.588.517-3.536 1.464A4.954 4.954 0 003 8c0 1.34.517 2.588 1.464 3.536A4.954 4.954 0 008 13c1.34 0 2.588-.517 3.536-1.464A4.954 4.954 0 0013 8c0-1.34-.517-2.588-1.464-3.536zM12.95 3.05A6.954 6.954 0 0115 8c0 1.87-.728 3.628-2.05 4.95A6.954 6.954 0 018 15a6.954 6.954 0 01-4.95-2.05A6.954 6.954 0 011 8c0-1.87.728-3.628 2.05-4.95A6.954 6.954 0 018 1c1.87 0 3.628.728 4.95 2.05zm-2.287 6.7a.646.646 0 01-.914.913L7.543 8.457A.646.646 0 017.353 8V5.588a.646.646 0 011.293 0v2.144l2.017 2.017z' />
  </svg>
);

export default SvgClockGlyph;
